import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export type UpdateApiKeyPayloadType = {
  name: string;
};

export const updateApiKeyApi = async (
  apiKeyId: string,
  payload: UpdateApiKeyPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/api-key/${apiKeyId}/`;

  return authApiService.PATCH(uri, payload);
};
